module.exports = __webpack_public_path__ + "static/media/TCA.80dab001.svg";